import { css } from '@emotion/react';
import type { Theme } from '~/_shared/themes/theme.model';

export const suffixInputStyle = ({ hasError }: Readonly<{ hasError?: boolean }>) => (theme: Theme) => css({
  background: theme.backgroundColors.secondary,
  border: `1px solid ${hasError ? theme.borderColors.error : theme.borderColors.primary }`,
  padding: '0 0 0 5px',
});
